var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaigns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5399 9.35834L17.0058 11.097L20.4831 10.1653L20.0172 8.42659L16.5399 9.35834ZM16.3409 15.5705C17.3409 15.9641 18.6465 16.4901 19.6795 16.9028C19.9038 16.3489 20.1257 15.7863 20.35 15.2324C19.317 14.8197 18.0114 14.2937 17.0091 13.8914C16.7872 14.454 16.5652 15.0166 16.3409 15.5705ZM17.3684 4.10489C16.8972 3.73732 16.4237 3.36105 15.9525 2.99348C15.2643 3.8674 14.3966 4.97574 13.7297 5.82528C14.2009 6.19285 14.6744 6.56912 15.1456 6.93669C15.8125 6.08715 16.6825 4.9875 17.3684 4.10489ZM3.90335 10.8808C2.94709 11.137 2.37433 12.1291 2.63056 13.0853L3.09643 14.824C3.35267 15.7803 4.34471 16.353 5.30097 16.0968L6.17031 15.8639L7.10206 19.3412L8.84072 18.8753L7.90897 15.398L8.77831 15.165L13.8238 16.6084L11.0285 6.17636L7.38068 9.94904L3.90335 10.8808ZM14.5995 10.81C14.2897 9.6538 13.506 8.7457 12.5152 8.24715L14.0735 14.063C14.6846 13.1445 14.9093 11.9662 14.5995 10.81Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaigns);
export default __webpack_public_path__ + "static/media/campaigns.373a0c84eef4cd9073850415a0956e73.svg";
export { ForwardRef as ReactComponent };